"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Factory_1 = require("./Factory");

var types_1 = require("../../types");

var Investment_1 = require("../Investment");

var Sto_1 = require("../Sto");

var SecurityToken_1 = require("../SecurityToken");

var PolymathError_1 = require("../../PolymathError");

var weiToValue = contract_wrappers_1.conversionUtils.weiToValue;
/**
 * Factory generates information for an Investment entity
 */

var InvestmentFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(InvestmentFactory, _Factory_1$Factory);

  /**
   * Create an instance of the Investment Factory
   */
  function InvestmentFactory(context) {
    var _this;

    _classCallCheck(this, InvestmentFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvestmentFactory).call(this, Investment_1.Investment, context));
    /**
     * @hidden
     */

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _Investment_1$Investm, stoId, securityTokenId, index, _Sto_1$Sto$unserializ, stoType, address, _SecurityToken_1$Secu, symbol, module, tokenPurchases, thisPurchase, _thisPurchase$args, beneficiary, amount, value, _module, _tokenPurchases, _thisPurchase, _thisPurchase$args2, _beneficiary, _usdAmount, _tokens;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _Investment_1$Investm = Investment_1.Investment.unserialize(uid), stoId = _Investment_1$Investm.stoId, securityTokenId = _Investment_1$Investm.securityTokenId, index = _Investment_1$Investm.index;
                _Sto_1$Sto$unserializ = Sto_1.Sto.unserialize(stoId), stoType = _Sto_1$Sto$unserializ.stoType, address = _Sto_1$Sto$unserializ.address;
                _SecurityToken_1$Secu = SecurityToken_1.SecurityToken.unserialize(securityTokenId), symbol = _SecurityToken_1$Secu.symbol;

                if (!(stoType === types_1.StoType.Simple)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 6;
                return this.context.contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.CappedSTO,
                  address: address
                });

              case 6:
                module = _context.sent;
                _context.next = 9;
                return module.getLogsAsync({
                  eventName: contract_wrappers_1.CappedSTOEvents.TokenPurchase,
                  blockRange: {
                    fromBlock: contract_wrappers_1.BlockParamLiteral.Earliest,
                    toBlock: contract_wrappers_1.BlockParamLiteral.Latest
                  },
                  indexFilterValues: {}
                });

              case 9:
                tokenPurchases = _context.sent;
                thisPurchase = tokenPurchases.find(function (_, eventIndex) {
                  return eventIndex === index;
                });

                if (thisPurchase) {
                  _context.next = 13;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "Investment ".concat(uid, " not found")
                });

              case 13:
                _thisPurchase$args = thisPurchase.args, beneficiary = _thisPurchase$args.beneficiary, amount = _thisPurchase$args.amount, value = _thisPurchase$args.value;
                return _context.abrupt("return", {
                  address: beneficiary,
                  tokenAmount: weiToValue(amount, contract_wrappers_1.FULL_DECIMALS),
                  investedFunds: weiToValue(value, contract_wrappers_1.FULL_DECIMALS),
                  securityTokenSymbol: symbol
                });

              case 17:
                if (!(stoType === types_1.StoType.Tiered)) {
                  _context.next = 31;
                  break;
                }

                _context.next = 20;
                return this.context.contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: address
                });

              case 20:
                _module = _context.sent;
                _context.next = 23;
                return _module.getLogsAsync({
                  eventName: contract_wrappers_1.USDTieredSTOEvents.TokenPurchase,
                  blockRange: {
                    fromBlock: contract_wrappers_1.BlockParamLiteral.Earliest,
                    toBlock: contract_wrappers_1.BlockParamLiteral.Latest
                  },
                  indexFilterValues: {}
                });

              case 23:
                _tokenPurchases = _context.sent;
                _thisPurchase = _tokenPurchases.find(function (_, eventIndex) {
                  return eventIndex === index;
                });

                if (_thisPurchase) {
                  _context.next = 27;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "Investment ".concat(uid, " not found")
                });

              case 27:
                _thisPurchase$args2 = _thisPurchase.args, _beneficiary = _thisPurchase$args2._beneficiary, _usdAmount = _thisPurchase$args2._usdAmount, _tokens = _thisPurchase$args2._tokens;
                return _context.abrupt("return", {
                  address: _beneficiary,
                  tokenAmount: weiToValue(_usdAmount, contract_wrappers_1.FULL_DECIMALS),
                  investedFunds: weiToValue(_tokens, contract_wrappers_1.FULL_DECIMALS),
                  securityTokenSymbol: symbol
                });

              case 31:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "Invalid STO type ".concat(stoType)
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    return _this;
  }

  return InvestmentFactory;
}(Factory_1.Factory);

exports.InvestmentFactory = InvestmentFactory;